import { GLOBALS } from "../../js/globals";
import { closeMenu } from "../mobile-menu/mobile-menu";

document.addEventListener('scroll', () => {
    const scroll = window.scrollY;

    if (scroll > 30) {
        GLOBALS.H.classList.add('_has-fixed-header');
    } else {
        GLOBALS.H.classList.remove('_has-fixed-header');
    }
});

document.querySelector('.js-logo')?.addEventListener('click', () => {
    closeMenu();
});
